import { render, staticRenderFns } from "./CASAProfileSetup.vue?vue&type=template&id=67310c66&"
import script from "./CASAProfileSetup.vue?vue&type=script&lang=js&"
export * from "./CASAProfileSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports